export function parseCsv(text: string): string[][] {
    const content = text.replace(/^\uFEFF/, '');
    const rows: string[][] = [];
    let row: string[] = [];
    let field = '';
    let inQuotes = false;

    for(let i = 0; i < content.length; i++) {
        const ch = content[i];

        if(inQuotes) {
            if(ch === '"') {
                if(content[i + 1] === '"') {
                    field += '"';
                    i++;
                }
                else {
                    inQuotes = false;
                }
            }
            else {
                field += ch;
            }
        }
        else if(ch === '"') {
            inQuotes = true;
        }
        else if(ch === ',') {
            row.push(field);
            field = '';
        }
        else if(ch === '\n' || ch === '\r') {
            if(ch === '\r' && content[i + 1] === '\n') i++;
            row.push(field);
            rows.push(row);
            row = [];
            field = '';
        }
        else {
            field += ch;
        }
    }

    if(field !== '' || row.length) {
        row.push(field);
        rows.push(row);
    }

    return rows;
}
